import { ProductCategoriesApi } from '@psl/generated/api';
import configuration from './configuration';

export default new ProductCategoriesApi(configuration);
